import Crud from "../views/Flow/Crud";
import Add from "../views/Flow/Add";
import Approvals from "../views/Flow/Approvals";
import Myapprovals from "../views/Flow/Myapprovals";
import View from "../views/Flow/View";
import InprogressView from "../views/Flow/InprogressView";
import TemplatesIndex from "../views/Flow/Templates/Index";
import TemplatesForm from "../views/Flow/Templates/Form";
import FormTemplatesIndex from "../views/Flow/FormTemplates/Index";
import FormTemplatesForm from "../views/Flow/FormTemplates/Form";

let routes = {
  path: "/flows",
  component: (resolve) =>
    require(["../layouts/full/LayoutFull"], resolve),
  children: [
    {
      path: "/Flow",
      name: "list-flow",
      component: Crud,
      meta: {
        pageTitle: "Solicitações ",
        breadcrumb: [{ text: "Solicitações ", active: true }],
      },
    },

    // ✅ NOVA SOLICITAÇÃO
    {
      path: "/Flow/new",
      name: "flow-new",
      component: Add,
      meta: {
        pageTitle: "Nova solicitação",
        breadcrumb: [
          { text: "Solicitações", to: "/Flow" },
          { text: "Nova solicitação", active: true },
        ],
      },
    },

    // ✅ APROVAÇÕES 
    {
      path: "/Flow/approvals",
      name: "flow-approvals",
      component: Approvals,
      meta: {
        pageTitle: "Aprovações",
        breadcrumb: [
          { text: "Solicitações", to: "/Flow" },
          { text: "Aprovações", active: true },
        ],
      },
    },

    // ✅ minhas aprovacoes 
    {
      path: "/Flow/my",
      name: "flow-my",
      component: Myapprovals,
      meta: {
        pageTitle: "Minhas solicitações",
        breadcrumb: [
          { text: "Solicitações", to: "/Flow" },
          { text: "Minhas solicitações", active: true },
        ],
      },
    },

    // ✅ VIEW
    {
      path: "/Flow/view/:id",
      name: "flow-view",
      component: View,
      meta: {
        pageTitle: "Visualizar fluxo",
        breadcrumb: [
          { text: "Solicitações", to: "/Flow" },
          { text: "Visualizar", active: true },
        ],
      },
    },

    // ✅ em andamento visualizacao
    {
      path: "/Flow/inprogressView/:id",
      name: "flow-inprogress-view",
      component: InprogressView,
      meta: {
        pageTitle: "Em andamento",
        breadcrumb: [
          { text: "Solicitações", to: "/Flow" },
          { text: "Visualizar", active: true },
        ],
      },
    },

    // ✅ MODELOS DE FLOW
    {
      path: "/Flow/templates",
      name: "flow-templates",
      component: TemplatesIndex,
      meta: {
        pageTitle: "Modelos de Flow",
        breadcrumb: [{ text: "Modelos de Flow", active: true }],
      },
    },
    {
      path: "/Flow/templates/new",
      name: "flow-template-new",
      component: TemplatesForm,
      meta: {
        pageTitle: "Novo modelo",
        breadcrumb: [
          { text: "Modelos de Flow", to: "/Flow/templates" },
          { text: "Novo modelo", active: true },
        ],
      },
    },
    {
      path: "/Flow/templates/edit/:id",
      name: "flow-template-edit",
      component: TemplatesForm,
      meta: {
        pageTitle: "Editar modelo",
        breadcrumb: [
          { text: "Modelos de Flow", to: "/Flow/templates" },
          { text: "Editar modelo", active: true },
        ],
      },
    },

    // ✅ MODELOS DE FORMULÁRIO
    {
      path: "/Flow/form-templates",
      name: "form-templates",
      component: FormTemplatesIndex,
      meta: {
        pageTitle: "Modelos de Formulário",
        breadcrumb: [{ text: "Modelos de Formulário", active: true }],
      },
    },
    {
      path: "/Flow/form-templates/new",
      name: "form-template-new",
      component: FormTemplatesForm,
      meta: {
        pageTitle: "Novo modelo de formulário",
        breadcrumb: [
          { text: "Modelos de Formulário", to: "/Flow/form-templates" },
          { text: "Novo modelo", active: true },
        ],
      },
    },
    {
      path: "/Flow/form-templates/edit/:id",
      name: "form-template-edit",
      component: FormTemplatesForm,
      meta: {
        pageTitle: "Editar modelo de formulário",
        breadcrumb: [
          { text: "Modelos de Formulário", to: "/Flow/form-templates" },
          { text: "Editar modelo", active: true },
        ],
      },
    },
  ],
};

export default routes;
